export const categoryBase = {

    data(){
        return {
        }
    },
    computed:{
        categories(){
			return this.$store.state.categories.all;
		},
		sortedCategories(){
			return this._.sortBy(this.categories, [c => c.name.toLowerCase()]);
        },
    },
    methods: {
        getCategoriesAsString(catIds){
			return this.getArrayAsString(this.categories,catIds);
		},
        getCategoryById(id){
			return this._.find(this.categories, ['id', id]); 
		}
    }
}